var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"permission":'reference',"fields":_vm.fields,"endpoint":'reference',"updatePossible":true,"publication":"","reference":"","hasAuthor":false,"previewModule":"referenties","module":'reference'}})}
var staticRenderFns = []

export { render, staticRenderFns }